import { Blockchain } from "@rarible/api-client"
import { toCurrencyId } from "../../../price/types"
import { FEE_CONFIG_URL } from "../constants"
import type { StaticEthereumBlockchainConfig } from "../types"

const injectiveTestnetViem = {
  id: 1439,
  name: "Injective EVM Testnet",
  nativeCurrency: {
    name: "Injective",
    symbol: "INJ",
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: ["https://k8s.testnet.json-rpc.injective.network"],
    },
  },
  blockExplorers: {
    default: {
      name: "Injective Testnet Explorer",
      url: "https://testnet.blockscout.injective.network",
    },
  },
  testnet: true,
}

export const injectiveTestnetConfig: StaticEthereumBlockchainConfig = {
  name: "Injective",
  icon: "/images/blockchains/injective.svg",
  isEvm: true,
  testnet: true,
  isTestnet: true,
  feesVersion: "v3",
  treasury: "0x64d34BcfC32Fb663172C47d6E4Fb1dBFaba6e7a2",
  unionApi: "https://api.rarible.org",
  basePath: "https://injectivetestnet-api.rarible.org",
  chainId: injectiveTestnetViem.id,
  blockchain: Blockchain.INJECTIVETESTNET,
  chainName: injectiveTestnetViem.name,
  exchange: {
    v2: "0xe6c2893b2F4F7ab2f6f22cF05509D1bD821380Ae",
    wrapper: "0x52e45bc6D0E22bbd42Db1B91299cAEED367b9afe",
  },
  blockExplorers: [
    {
      url: "https://testnet.blockscout.injective.network",
      icon: "/images/scanner.svg",
      adress: "https://testnet.blockscout.injective.network/address/${adrress}",
    },
  ],
  rpcUrls: [],
  privateRpcNodeSlug: "testnet-injective-node",
  transferProxies: {
    nft: "0x34988c0b2Ba9095F4f13aD19070d6776c6107Cd0",
    erc721Lazy: "0xB9e873D8a64D3e8A5D93a7F2fAe94DDCe5E0E72b",
    erc20: "0xc747f8bA0514D30322a5BD4056F8c6434448D3F5",
  },
  feeConfigUrl: FEE_CONFIG_URL,
  primaryCurrency: {
    id: toCurrencyId(
      "INJECTIVETESTNET:0x0000000000000000000000000000000000000000",
    ),
    symbol: "INJ",
    name: "Injective",
    decimals: 18,
  },
  wrappedCurrency: {
    id: toCurrencyId(
      "INJECTIVETESTNET:0x5ae9b425f58b78e0d5e7e5a7a75c5f5b45d143b7",
    ),
    symbol: "WINJ",
    name: "Wrapped Injective",
    decimals: 18,
  },
  addFundsLink: "https://testnet.faucet.injective.network/",
  hasStabilityProtocol: true,
  viem: injectiveTestnetViem,
}

export const getInjectiveTestnetConfig = (): StaticEthereumBlockchainConfig =>
  injectiveTestnetConfig
